import { render, staticRenderFns } from "./ElInput.vue?vue&type=template&id=163cef92"
import script from "./ElInput.vue?vue&type=script&lang=js"
export * from "./ElInput.vue?vue&type=script&lang=js"
import style0 from "./ElInput.vue?vue&type=style&index=0&id=163cef92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports